import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import CurrentUserWatchlistTickersQuery from 'buyside/graphql/queries/CurrentUserWatchlistTickersQuery';
import FollowItemMutation from 'buyside/graphql/mutations/FollowItem';
import UnfollowItemMutation from 'buyside/graphql/mutations/UnfollowItem';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import WatchlistedTickersTable from 'buyside/components/presentation/UserAccount/WatchlistedTickers/watchlistedTickersTable';

const Entity = 'ENTITY';

const WatchlistedTickersContainer = () => (
  <Query query={CurrentUserWatchlistTickersQuery}>
    {({ loading, data = {} }) => {
      return (
        <Mutation
          mutation={UnfollowItemMutation}
          refetchQueries={[{ query: CurrentUserWatchlistTickersQuery }]}
        >
          {mutate => {
            const unfollowObject = ({ followId }) =>
              mutate({ variables: { followId, type: Entity } });
            return (
              <Mutation
                mutation={FollowItemMutation}
                refetchQueries={[{ query: CurrentUserWatchlistTickersQuery }]}
              >
                {mutate => {
                  const followEntity = ({ followId }) =>
                    mutate({ variables: { followId, type: Entity } });
                  if (loading) return <LoadingSpinner size={SIZES.LARGE} />;
                  return (
                    <WatchlistedTickersTable
                      followEntity={followEntity}
                      unfollowEntity={unfollowObject}
                      currentUser={data.currentUser}
                    />
                  );
                }}
              </Mutation>
            );
          }}
        </Mutation>
      );
    }}
  </Query>
);

export default WatchlistedTickersContainer;
